/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProposalStepNameType = {
    Step1: 'Step1',
    Step2: 'Step2',
    Step3: 'Step3',
    Step4: 'Step4',
    Step5: 'Step5',
    Step6: 'Step6',
    Step5_PersonalDetails: 'Step5_PersonalDetails',
    Step5_EmploymentAndTax: 'Step5_EmploymentAndTax',
    Step5_SecondLifeDetails: 'Step5_SecondLifeDetails',
    Step5_ThirdParties: 'Step5_ThirdParties',
    Step5_PaymentMethods: 'Step5_PaymentMethods',
    Step5_AppointIntermediary: 'Step5_AppointIntermediary',
    Step5_TrustAndPolicyDetails: 'Step5_TrustAndPolicyDetails',
    Step5_TaxDetails: 'Step5_TaxDetails',
    Step5_RelatedParties: 'Step5_RelatedParties',
    Step3_Scenarios: 'Step3_Scenarios',
    Step5_JustPortfolio: 'Step5_JustPortfolio'
} as const;
export type ProposalStepNameType = typeof ProposalStepNameType[keyof typeof ProposalStepNameType];


export function ProposalStepNameTypeFromJSON(json: any): ProposalStepNameType {
    return ProposalStepNameTypeFromJSONTyped(json, false);
}

export function ProposalStepNameTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalStepNameType {
    return json as ProposalStepNameType;
}

export function ProposalStepNameTypeToJSON(value?: ProposalStepNameType | null): any {
    return value as any;
}

